<template>
  <div>
    
    <CCard class="custom-card h-100 mt-5"><br />
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <br />
              <br />
              <h4 class="ml-6 mt-5" style="font-size:24px">
                List Question
              </h4>
              <br />

              <CCard style="
                background-color: #e6f0ff;
                border-color: #80b3ff;
                border-radius: 20px;
              "
              class="col-12"
            >
              <CRow class="text-left mt-3 mb-3">
                <CCol class="col-12">
                  <p>
                    <strong>Question 1 :</strong>
                  </p>

                  <p>
                    I've _____ a few photos and a video of me on my holiday to this email.
                  </p>

                  <CRow class="col-12">
                  <p style="margin-bottom: 0px">
                    C. attached
                  </p> &nbsp;

                  <img src="../assets/img/iconsuccess.png" width="30px" height="30px">
                  </CRow>
                  
                </CCol>                
              </CRow>

              <!-- <div
                class="col-12 text-center"
                v-if="item.questionImagePath != null"
              >
                <CRow class="justify-content-center">
                  <CCard
                    style="background: #ffffff; border: #000000"
                    class="box-shadow"
                    @click="
                      ViewFullImage(
                        item.questionFolderName,
                        item.questionImageName
                      )
                    "
                  >
                    <img class="image" :src="getPic(item)" />
                  </CCard>
                </CRow>
              </div> -->
            </CCard>

            <CCard style="
                background-color: #e6f0ff;
                border-color: #80b3ff;
                border-radius: 20px;
              "
              class="col-12"
            >
              <CRow class="text-left mt-3 mb-3">
                <CCol class="col-12">
                  <p>
                    <strong>Question 2 :</strong>
                  </p>

                  <p>
                    Erna forgot to _____ what time the play would start.
                  </p>

                  <CRow class="col-12">
                  <p style="margin-bottom: 0px">
                    C. mention
                  </p> &nbsp;

                  <img src="../assets/img/iconsuccess.png" width="30px" height="30px">
                  </CRow>
                  
                </CCol>                
              </CRow>
              </CCard>

              <CCard class="col-12" style="
                background-color: #e6f0ff;
                border-color: #80b3ff;
                border-radius: 20px;
                "       
                @click="ViewAnswer()"
              >
                <CRow class="text-left mt-3 mb-3">
                  <CCol class="col-12">
                    <p>
                      <strong>Question 3 :</strong>
                    </p>

                    <p>
                      Farid has been _____ his parents to buy him a new bike for months.
                    </p>

                    <CRow class="col-12">
                      <p style="margin-bottom: 0px">
                        D. yelling
                      </p> &nbsp;

                      <img src="../assets/img/iconerror.png" width="30px" height="30px">
                    </CRow>                    
                  </CCol>                
                </CRow>
              </CCard>

              <CCard class="col-12" style="
                background-color: #e6f0ff;
                border-color: #80b3ff;
                border-radius: 20px;
              "
              @click="ViewAnswer()"
            >
              <CRow class="text-left mt-3 mb-3">
                <CCol class="col-12">
                  <p>
                    <strong>Question 4 :</strong>
                  </p>

                  <p>
                    Suresh isn't really a big fan _____ action films.
                  </p>

                  <CRow class="col-12">
                  <p style="margin-bottom: 0px">
                    A. with
                  </p> &nbsp;

                  <img src="../assets/img/iconerror.png" width="30px" height="30px">
                  </CRow>
                  
                </CCol>                
              </CRow>
              </CCard>

              <CCard style="
                background-color: #e6f0ff;
                border-color: #80b3ff;
                border-radius: 20px;
              "
              class="col-12"
            >
              <CRow class="text-left mt-3 mb-3">
                <CCol class="col-12">
                  <p>
                    <strong>Question 5 :</strong>
                  </p>

                  <p>
                    I find SN sites a great way to keep in _____ with old school friends.
                  </p>

                  <CRow class="col-12">
                  <p style="margin-bottom: 0px">
                    B. touch
                  </p> &nbsp;

                  <img src="../assets/img/iconsuccess.png" width="30px" height="30px">
                  </CRow>
                  
                </CCol>                
              </CRow>
              </CCard>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>

    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100% !important;
        top: 0px;
        right: 0px;
        left: 0px;
        z-index: 1;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div style="width: 100%" class="col-12 mt-4">
        <div class="col-12">
          <CCard class="col-12 coin-right">
            <CRow>
              <img src="../assets/img/coin.png" width="40px" height="40px" style="margin-left: -20px; margin-top: -8px; margin-bottom: -15px"/>
              <p style="font-size: 17px; margin-top: 0px;
              margin-bottom: 0px;"><strong>150</strong></p>
              <div class="text-right">
              <img src="../assets/img/iconAdd.png" class="text-right" width="35px" height="35px" style="margin-right: -45px; margin-top: -10px; margin-bottom: -10px;" @click="EShop()"/>
              </div>
            </CRow>
          </CCard>
        </div>
          <br />
        
        <CCol sm="12">
          <span class="mt-5 mb-5"> </span>
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>

    

    

    <CModal title="View Answer" size="sm" :show.sync="ViewAnswerModal">                
      <h5 class="text-center">To view right answer, 1 coin will be deducted for each answer display. Proceed?</h5>          
      <template #footer>
        <CButton color="primary" @click="GoToAnswerPreview()">Yes</CButton>

        <CButton color="danger" @click="RefreshModal()">No</CButton>
      </template>
    </CModal>

  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import backgroundBanner from "../assets/img/bgApps.jpg";
// Tell Vue to install the plugin.
export default {
  name: "Login",
  components: {},
  data() {
    return {
      backgroundBanner,      
      PurchaseCoinModal: false,
      ViewAnswerModal: false,
    };
  },
  async mounted() {},
  computed: {},
  methods: {    
    EShop() {
      this.$router.push(
        "/QuizStudentSubscription?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          this.$route.query.studentId
      );
    },
    ViewAnswer() {
      this.ViewAnswerModal = true;
    },
    GoToAnswerPreview() {
      this.$router.push(
        "/QuizStudentAnswerPreview?quizScoreId=" +
        this.$route.query.quizScoreId +
        "&studentId=" +
        this.$route.query.studentId +
        "&userId=" +
        this.$route.query.userId
      )
    },
    RefreshModal() {
      this.ViewAnswerModal = false;
    },
  },
};
</script>

<style>
.coin-right {
  border-radius: 30px;
  border-color: #ffff00;
  border-width: 3px;
  color: #000000;          
  width: 20%;
  position: absolute;
  top: 50%;
  left: 80%;
  transform: translate(-30%, -10%);
  background: rgb(255,255,255);
  background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,220,160,0.8015581232492998) 80%);
}
.coin_card{
  background: rgb(179,155,255);
background: linear-gradient(180deg, rgba(179,155,255,0.5914740896358543) 10%, rgba(255,220,160,0.8015581232492998) 60%);
}

.coin_card2{
 background: rgb(255,220,160);
background: linear-gradient(180deg, rgba(255,220,160,0.8015581232492998) 40%, rgba(179,155,255,0.6194852941176471) 80%);
}
</style>